export enum BrandingColor {
  Blue = 'blue',
  White = 'white',
  Grey = 'grey',
}
